
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5qO2k", function(module, exports) {
// Intent-time preload seam for chat-side modules. Fire-and-forget; experiment-gated; once per page load.

var $cXtTj = parcelRequire("cXtTj");

// Intent-time preload for the LazyCardWithUrlContent chunk; chunk name mirrors `view/CardWithUrl/loader.tsx`.

const $8f621f3867006eb3$export$e8ff3768de40dcb2 = ()=>(parcelRequire("iihQ1"));



var $hyOW3 = parcelRequire("hyOW3");


var $fDOrD = parcelRequire("fDOrD");


var $jv1SC = parcelRequire("jv1SC");

const $6e95e9a207754122$var$PRELOADER_SMART_CARD = 'smart-card';
const $6e95e9a207754122$var$PRELOADER_AUTO_SUGGEST = 'auto-suggest';
const $6e95e9a207754122$var$PRELOADER_SMART_CREATION = 'smart-creation';
const $6e95e9a207754122$var$PRELOADER_FEEDBACK_FLAG = 'feedback-flag';
const $6e95e9a207754122$var$ALL_PRELOADERS = [
    $6e95e9a207754122$var$PRELOADER_SMART_CARD,
    $6e95e9a207754122$var$PRELOADER_AUTO_SUGGEST,
    $6e95e9a207754122$var$PRELOADER_SMART_CREATION,
    $6e95e9a207754122$var$PRELOADER_FEEDBACK_FLAG
];
let $6e95e9a207754122$var$hasPreloadedChatOnIntent = false;
function $6e95e9a207754122$var$isPreloaderName(preloader) {
    return $6e95e9a207754122$var$ALL_PRELOADERS.includes(preloader);
}
function $6e95e9a207754122$var$getEnabledPreloaders(cohort) {
    return new Set(cohort.split(',').map((preloader)=>preloader.trim()).filter(Boolean).filter($6e95e9a207754122$var$isPreloaderName));
}
function $6e95e9a207754122$var$preloadSmartCard() {
    (0, $8f621f3867006eb3$export$e8ff3768de40dcb2)().catch(()=>{});
}
function $6e95e9a207754122$var$preloadAutoSuggest() {
    (0, $hyOW3.importAutoSuggest)().catch(()=>{});
}
function $6e95e9a207754122$var$preloadSmartCreationWrapper() {
    (0, $jv1SC.importSmartCreationWrapper)().catch(()=>{});
}
function $6e95e9a207754122$var$preloadFeedbackFlag() {
    (0, $fDOrD.importFeedbackFlag)().catch(()=>{});
}
function $6e95e9a207754122$export$778f6ecee92cc30c() {
    if (typeof window === 'undefined') return;
    if ($6e95e9a207754122$var$hasPreloadedChatOnIntent) return;
    $6e95e9a207754122$var$hasPreloadedChatOnIntent = true;
    const enabledPreloaders = $6e95e9a207754122$var$getEnabledPreloaders((0, $cXtTj.default).getExperimentValue('chat_preload_components_exp', 'cohort', '', {
        fireExperimentExposure: true
    }));
    if (enabledPreloaders.size === 0) return;
    if (enabledPreloaders.has($6e95e9a207754122$var$PRELOADER_SMART_CARD)) $6e95e9a207754122$var$preloadSmartCard();
    if (enabledPreloaders.has($6e95e9a207754122$var$PRELOADER_AUTO_SUGGEST)) $6e95e9a207754122$var$preloadAutoSuggest();
    if (enabledPreloaders.has($6e95e9a207754122$var$PRELOADER_SMART_CREATION)) $6e95e9a207754122$var$preloadSmartCreationWrapper();
    if (enabledPreloaders.has($6e95e9a207754122$var$PRELOADER_FEEDBACK_FLAG)) $6e95e9a207754122$var$preloadFeedbackFlag();
}
module.exports["preloadChatOnIntent"] = $6e95e9a207754122$export$778f6ecee92cc30c;

});

parcelRegister("iihQ1", function(module, exports) {

let $d517beb79ab70780$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d517beb79ab70780$var$load("iNoxQ"),
    $d517beb79ab70780$var$load("lOm4J"),
    $d517beb79ab70780$var$load("8thxw"),
    $d517beb79ab70780$var$load("7FMMX"),
    $d517beb79ab70780$var$load("eRhBr"),
    $d517beb79ab70780$var$load("6HpsR"),
    $d517beb79ab70780$var$load("N3oqb"),
    $d517beb79ab70780$var$load("hZ2FX"),
    $d517beb79ab70780$var$load("9ZFGK"),
    $d517beb79ab70780$var$load("2hLAI"),
    $d517beb79ab70780$var$load("dCilB"),
    $d517beb79ab70780$var$load("h1yOv"),
    $d517beb79ab70780$var$load("1T8H1"),
    $d517beb79ab70780$var$load("fyKFO"),
    $d517beb79ab70780$var$load("d9sg7"),
    $d517beb79ab70780$var$load("l0N35"),
    $d517beb79ab70780$var$load("bU9L5"),
    $d517beb79ab70780$var$load("fuOfV"),
    $d517beb79ab70780$var$load("iZR3N"),
    $d517beb79ab70780$var$load("4zz48"),
    $d517beb79ab70780$var$load("jXM1T"),
    $d517beb79ab70780$var$load("cvcNg"),
    $d517beb79ab70780$var$load("jw3lv"),
    $d517beb79ab70780$var$load("7rqWx"),
    $d517beb79ab70780$var$load("aIze1"),
    $d517beb79ab70780$var$load("il8bj"),
    $d517beb79ab70780$var$load("4N1MY"),
    $d517beb79ab70780$var$load("kG5Ju"),
    $d517beb79ab70780$var$load("39XCn"),
    $d517beb79ab70780$var$load("3Cky6"),
    $d517beb79ab70780$var$load("jL1Ke"),
    $d517beb79ab70780$var$load("5MQ0D"),
    $d517beb79ab70780$var$load("aFLSJ"),
    $d517beb79ab70780$var$load("6fJCf"),
    $d517beb79ab70780$var$load("duEFL"),
    $d517beb79ab70780$var$load("6wr18"),
    $d517beb79ab70780$var$load("1pJPT"),
    $d517beb79ab70780$var$load("8zMmc"),
    $d517beb79ab70780$var$load("4x9Jx"),
    $d517beb79ab70780$var$load("7EorR"),
    $d517beb79ab70780$var$load("ffEVr"),
    $d517beb79ab70780$var$load("2EIkU"),
    $d517beb79ab70780$var$load("Wowvf"),
    $d517beb79ab70780$var$load("hhss7"),
    $d517beb79ab70780$var$load("cbF85")
]).then(()=>parcelRequire('9gHOR'));

});

parcelRegister("hyOW3", function(module, exports) {
// Canonical dynamic-import factory for `@atlassian/conversation-assistant-auto-suggest`. Shared by the live
// `lazy()` boundary and intent-time preload to keep chunk identity single-sourced.

function $04373e772f510be6$export$5531859f311f2932() {
    return (parcelRequire("7HkeB"));
}
module.exports["importAutoSuggest"] = $04373e772f510be6$export$5531859f311f2932;

});

parcelRegister("7HkeB", function(module, exports) {

let $59ac3eb9b9b836f7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $59ac3eb9b9b836f7$var$load("8thxw"),
    $59ac3eb9b9b836f7$var$load("7FMMX"),
    $59ac3eb9b9b836f7$var$load("6wr18"),
    $59ac3eb9b9b836f7$var$load("ffEVr"),
    $59ac3eb9b9b836f7$var$load("eCXJR"),
    $59ac3eb9b9b836f7$var$load("1VTX2"),
    $59ac3eb9b9b836f7$var$load("2EIkU"),
    $59ac3eb9b9b836f7$var$load("eRhBr"),
    $59ac3eb9b9b836f7$var$load("hZ2FX"),
    $59ac3eb9b9b836f7$var$load("hhss7"),
    $59ac3eb9b9b836f7$var$load("kT6dz"),
    $59ac3eb9b9b836f7$var$load("aAWLw"),
    $59ac3eb9b9b836f7$var$load("lRgOm")
]).then(()=>parcelRequire('79mXg'));

});

parcelRegister("fDOrD", function(module, exports) {
// Single-source dynamic import factory for the feedback-flag chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $e837e744ff2037be$export$1eafe3a5df99a0a0 = ()=>(parcelRequire("wRQb5"));
module.exports["importFeedbackFlag"] = $e837e744ff2037be$export$1eafe3a5df99a0a0;

});

parcelRegister("wRQb5", function(module, exports) {

let $062cc0e3f374f5be$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $062cc0e3f374f5be$var$load("hMCSF").then(()=>parcelRequire('3XAon'));

});

parcelRegister("jv1SC", function(module, exports) {
// Single-source dynamic import factory for the smart-creation-wrapper chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $bf344f5862a0f71d$export$f67978e62543a686 = ()=>(parcelRequire("1OFPN"));
module.exports["importSmartCreationWrapper"] = $bf344f5862a0f71d$export$f67978e62543a686;

});

parcelRegister("1OFPN", function(module, exports) {

let $152ae96bf0803842$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $152ae96bf0803842$var$load("4ZKBo"),
    $152ae96bf0803842$var$load("3WmaY"),
    $152ae96bf0803842$var$load("7gL7H"),
    $152ae96bf0803842$var$load("7TnhR"),
    $152ae96bf0803842$var$load("hUbK8"),
    $152ae96bf0803842$var$load("68hpv"),
    $152ae96bf0803842$var$load("1r4R9"),
    $152ae96bf0803842$var$load("bx5S2"),
    $152ae96bf0803842$var$load("7fsAO"),
    $152ae96bf0803842$var$load("knuqf"),
    $152ae96bf0803842$var$load("ipIDQ"),
    $152ae96bf0803842$var$load("agv3Q"),
    $152ae96bf0803842$var$load("garBx"),
    $152ae96bf0803842$var$load("eyY0h"),
    $152ae96bf0803842$var$load("5HweM"),
    $152ae96bf0803842$var$load("3bz2q"),
    $152ae96bf0803842$var$load("eRcQY"),
    $152ae96bf0803842$var$load("by6h6"),
    $152ae96bf0803842$var$load("j3345"),
    $152ae96bf0803842$var$load("2J2X1"),
    $152ae96bf0803842$var$load("7xLM7"),
    $152ae96bf0803842$var$load("Mjfig"),
    $152ae96bf0803842$var$load("e7Dyr"),
    $152ae96bf0803842$var$load("cPAXo"),
    $152ae96bf0803842$var$load("44j0l"),
    $152ae96bf0803842$var$load("6hYei"),
    $152ae96bf0803842$var$load("fJEib"),
    $152ae96bf0803842$var$load("46GUH"),
    $152ae96bf0803842$var$load("dxcsb"),
    $152ae96bf0803842$var$load("gbejv"),
    $152ae96bf0803842$var$load("GD9EA"),
    $152ae96bf0803842$var$load("2hLAI"),
    $152ae96bf0803842$var$load("dCilB"),
    $152ae96bf0803842$var$load("1T8H1"),
    $152ae96bf0803842$var$load("fyKFO"),
    $152ae96bf0803842$var$load("d9sg7"),
    $152ae96bf0803842$var$load("l0N35"),
    $152ae96bf0803842$var$load("iNoxQ"),
    $152ae96bf0803842$var$load("lOm4J"),
    $152ae96bf0803842$var$load("9LVeR"),
    $152ae96bf0803842$var$load("8exG0"),
    $152ae96bf0803842$var$load("gnocL"),
    $152ae96bf0803842$var$load("kT6dz"),
    $152ae96bf0803842$var$load("8thxw"),
    $152ae96bf0803842$var$load("7FMMX"),
    $152ae96bf0803842$var$load("6wr18"),
    $152ae96bf0803842$var$load("av7K3"),
    $152ae96bf0803842$var$load("hZVEi"),
    $152ae96bf0803842$var$load("fcsnw"),
    $152ae96bf0803842$var$load("ffEVr"),
    $152ae96bf0803842$var$load("eCXJR"),
    $152ae96bf0803842$var$load("1VTX2"),
    $152ae96bf0803842$var$load("ddvkk"),
    $152ae96bf0803842$var$load("3upHR"),
    $152ae96bf0803842$var$load("hhss7"),
    $152ae96bf0803842$var$load("Wowvf"),
    $152ae96bf0803842$var$load("eRhBr"),
    $152ae96bf0803842$var$load("hZ2FX"),
    $152ae96bf0803842$var$load("cKDij"),
    $152ae96bf0803842$var$load("7EorR"),
    $152ae96bf0803842$var$load("ce05o"),
    $152ae96bf0803842$var$load("4CnWt")
]).then(()=>parcelRequire('j1zzQ'));

});


//# sourceMappingURL=preload-chat-on-intent.3ba7c3fe.js.map
